import {createApp} from 'vue';
import UUID from "vue-uuid";
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import Recommendation from './views/networkers/Recommendation.vue';
import ContactCard from './components/cards/ContactCard';
import CompaniesCard from './components/CompaniesCard';
import CustomButton from './components/inputs/CustomButton';
import Dialog from "./components/Dialog"
import Toast, {POSITION, TYPE, useToast} from "vue-toastification";
import langHelper, {supportedLanguages} from "./locales/lang-helper";
import Loading from 'vue-loading-overlay';
import VueMatomo from 'vue-matomo';
import CreateProfile from "./components/CreateProfile";
import ProfileOthers from "./views/Profile-Others";
import VideoChat from "./views/VideoChat";
import VueFormWizard from "vue3-form-wizard";
import IncomingCallPopup from "./components/IncomingCallPopup";
import CustomSelect from "./components/inputs/CustomSelect";
import { Vue3Mq } from "vue3-mq";
import PerfectScrollbar  from 'vue3-perfect-scrollbar/src/index'
import moment from "moment";
import {OnlineContactsStorage} from "./localstorage/online-contacts-storage";
import NotificationComponent from './components/Notifications/NotificationComponent';
import VueLazyload from 'vue-lazyload';
import {getOffsetTop, isDefined} from "./utils";
import {AppointmentsStorage} from "./views/appointments/AppointmentsStorage";
import {ThemesStorage} from "./themes/storage/themes-storage";
import mitt from 'mitt';

import '../node_modules/vue3-emoji-picker/dist/style.css'
import "vue-toastification/dist/index.css";
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue3-form-wizard/dist/style.css'
import {Logger} from "./logger";
import {CountriesStorage} from "./themes/storage/countries-storage";

export const logger = new Logger();
export const themesStorage = new ThemesStorage();
export const countriesStorage = new CountriesStorage();
export const eventBus = mitt();
export const onlineContactsStorage = new OnlineContactsStorage();
export const appointmentsStorage = new AppointmentsStorage();

i18n.global.locale = langHelper.getCurrentLang();

const app = createApp(App).use(i18n);

document.addEventListener("visibilitychange",() => {
    eventBus.emit('visibilitychange');
},false);



//Components
app.component('Recommendation', Recommendation);
app.component('custom-button', CustomButton);
app.component('custom-dialog', Dialog);
app.component('ContactCard', ContactCard);
app.component('CompaniesCard', CompaniesCard);
app.component("loading", Loading);
app.component("create-profile", CreateProfile);
app.component("profile-others", ProfileOthers);
app.component('video-chat', VideoChat);
app.component('incoming-call-popup', IncomingCallPopup);
app.component('custom-select', CustomSelect);
app.component('notifications', NotificationComponent)
//Prototypes
app.config.globalProperties.$getCurrentLanguage = langHelper.getCurrentLang;
app.config.globalProperties.$getSupportedLanguages = supportedLanguages;
app.config.globalProperties.$isUsingOAuth = process.env.VUE_APP_OAUTH_URL != null && process.env.VUE_APP_OAUTH_URL.length > 0;
app.config.globalProperties.$isMyBookFair = process.env.VUE_APP_MYBOOKFAIR_USER_HOST != null && process.env.VUE_APP_MYBOOKFAIR_USER_HOST.length > 0;
app.config.globalProperties.$createProfileEnabled = process.env.VUE_APP_ENABLE_PROFILE_CREATE === 'true';
app.config.globalProperties.$showAdditionalInfoDialog = process.env.VUE_APP_ENABLE_ADDITIONAL_INFO_DIALOG === 'true';
app.config.globalProperties.$appVersion = process.env.VUE_APP_VERSION;
app.config.globalProperties.$splitChatAndContactRequests = process.env.VUE_APP_SPLIT_CHAT_AND_CONTACT_REQUESTS === 'true'
app.config.globalProperties.$incomingCallTimeBeforeClose = process.env.VUE_APP_INCOMING_CALL_TIME_BEFORE_CLOSE;
app.config.globalProperties.$enableGroups = process.env.VUE_APP_ENABLE_GROUPS === 'true';
app.config.globalProperties.$enableVideoCollection = process.env.VUE_APP_ENABLE_VIDEO_COLLECTION === 'true';
app.config.globalProperties.$enableCompanies = process.env.VUE_APP_ENABLE_COMPANIES === 'true';
app.config.globalProperties.$enableCorporates = process.env.VUE_APP_ENABLE_CORPORATES === 'true';
app.config.globalProperties.$enableAppointments = process.env.VUE_APP_ENABLE_APPOINTMENTS === 'true';
app.config.globalProperties.$showInviteContactButton = process.env.VUE_APP_SHOW_INVITE_CONTACT_BUTTON === 'true';
app.config.globalProperties.$showReserveTimeButton = process.env.VUE_APP_SHOW_RESERVE_TIME_BUTTON === 'true';
app.config.globalProperties.$enableVideoChat = process.env.VUE_APP_ENABLE_VIDEO_CHAT === 'true';
app.config.globalProperties.$enablePresetFilter = process.env.VUE_APP_FILTER_PRESET_WITH_OWN_THEMES === 'true'
app.config.globalProperties.$splitFilterThemes = process.env.VUE_APP_SPLIT_FILTER_THEMES === 'true'
app.config.globalProperties.$enableHideUnhideUserHandling = process.env.VUE_APP_ENABLE_HIDE_UNHIDE_USER_HANDLING === 'true';
app.config.globalProperties.$onlyAppointments = process.env.VUE_APP_ONLY_APPOINTMENTS === 'true';
app.config.globalProperties.$showCanceledAppointments = process.env.VUE_APP_SHOW_CANCELED_APPOINTMENTS === 'true';
app.config.globalProperties.$enableAppointmentRating = process.env.VUE_APP_ENABLE_APPOINTMENT_RATING === 'true';
app.config.globalProperties.$matchMakingExhibitorRole = process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE;
app.config.globalProperties.$enableDashboard = process.env.VUE_APP_ENABLE_DASHBOARD === 'true';
app.config.globalProperties.$toasted = useToast();
app.config.globalProperties.$showNoAppointmentsButton = process.env.VUE_APP_SHOW_NO_APPOINTMENTS_BUTTON === 'true';
app.config.globalProperties.$disableEMailInput = process.env.VUE_APP_DISABLE_EMAIL_INPUT === 'true';
app.config.globalProperties.$enableFilterNetworkerCount = process.env.VUE_APP_ENABLE_FILTER_NETWORKER_COUNT === 'true';

moment.locale(langHelper.getCurrentLang());

app.use(UUID);
app.use(VueFormWizard);
app.use(Toast,{
    shareAppContext: true,
    position: POSITION.BOTTOM_RIGHT,
    toastDefaults:{
        [TYPE.ERROR]: {
            timeout: 10000,
        },
        [TYPE.SUCCESS]: {
            timeout: 5000,
            hideProgressBar: false,
        }
    }
});
app.use(PerfectScrollbar);
app.use(VueLazyload, {lazyComponent: true});



app.use(Vue3Mq, {
    breakpoints: {
        mobile: 0,
        desktop: 600,
    }
});

if (process.env.VUE_APP_MATOMO_ENABLED === 'true') {
    app.use(VueMatomo, {
        siteId: process.env.VUE_APP_MATOMO_ID,
        host: process.env.VUE_APP_MATOMO_URL,
        trackInitialView: false,    // Whether to track the initial page view
        enableLinkTracking: false,  //Enables link tracking on regular links. Note that this won't
        debug: true
    });
}


window.onerror = null;

app.config.errorHandler = (error, vm, info) => {
    logger.error(error)
    console.log(error)
    let vueData;
    try {
        const maxDataLength = 100000;
        let data = JSON.stringify(vm._data, null, 2);
        if (data.length > maxDataLength) {
            vueData = data.substring(0, maxDataLength) + '…';
        } else {
            vueData = vm._data;
        }
    } catch (error) {
        vueData = error.message;
    }

    logger.sendErrorDump(error, vueData);

};

document.onkeydown = function (e) {
    if (e.key == process.env.VUE_APP_SEND_ERROR_DUMP_KEY && e.altKey && e.ctrlKey) {
        e.preventDefault();
        logger.sendBasicErrorDump();
    } else if (e.key == 's' && e.ctrlKey) {
        //Prevent Browser Save Dialog to open.
        e.preventDefault();
    }
}


window.onscroll = function () {
    const header = document.getElementById('header');
    if (isDefined(header)) {
        const headerHeight = header.offsetHeight
        const sticky = getOffsetTop(document.getElementById('app')) - headerHeight;
        header.style['transition-property'] = 'opacity';
        header.style['transition-delay'] = '1s';
        if (window.scrollY > sticky) {
            header.style.opacity = '0'
        } else {
            header.style.opacity = '1'
        }
    }
}


const startAppPromises = [];
startAppPromises.push(themesStorage.loadThemes());
startAppPromises.push(countriesStorage.loadCountries());
startAppPromises.push(appointmentsStorage.loadRooms())

app.use(router)


Promise.all(startAppPromises).then(() => {
        app.mount('#app');
    }, error => {
        //TODO error message when themes could not be loaded
        const appContent = document.getElementById("app");
        appContent.innerHTML = "<center><span style='color:white'>We're sorry, your browser is not supported.</span></center>";
    }
);

